// Redux action types
export const SET = 'one-state-department-athena/set';
export const REINIT = 'one-state-department-athena/reinit';

